<template>
  <div>
    <BSButton ref='bsButton' @notice='notice' @search='search' :addDeviceBtn='addBoolean' :delDeviceBtn='delBoolean' :upGradeBtn='false' :patchUpgradeBtn='false' :downGradeBtn='false' :synVersionBtn='synBoolean' :changeGPSBtn='gpsBoolean' :importBtn='gpsBoolean' :exportBtn='gpsBoolean'></BSButton>
    <BSTable ref='bsTable'></BSTable>
    <!-- 添加设备对话框 -->
    <CustomDialog ref='deviceDialog' v-bind:element='devDialog.element' :styles='devDialog.styles'>
      <template v-slot:dialog-content>
        <addBSDevice ref='addDev' @close='addCancel' @getDeviceListData="getDeviceListData"></addBSDevice>
      </template>
    </CustomDialog>
     <!-- 修改设备对话框 -->
    <CustomDialog ref='updateDevice' :element='updateDevDialog.element' :styles='updateDevDialog.styles' :messages='updateDevDialog.messages'>
      <template v-slot:dialog-content>
        <UpdateDevice ref="updatedev" @close='updateCancel'  @getDeviceListData="getDeviceListData"></UpdateDevice>
      </template>
    </CustomDialog>
    <!-- 设备升级、回退对话框-->
    <CustomDialog ref='upGradeDlg' v-bind:element='upDialog.element' :styles='upDialog.styles'>
      <template v-slot:dialog-content>
        <!-- <DeviceVersion ref='upDevice'></DeviceVersion> -->
        <VersionUpdate ref='upDevice'></VersionUpdate>
      </template>
    </CustomDialog>
    <!-- 设备回退对话框-->
    <CustomDialog ref='downGradeDlg' v-bind:element='reDialog.element' :styles='reDialog.styles'>
      <template v-slot:dialog-content>
        <!-- <DeviceVersion ref='upDevice'></DeviceVersion> -->
        <VersionBack ref='downDevice'></VersionBack>
      </template>
    </CustomDialog>
    <!-- 更改GPS对话框 -->
    <CustomDialog ref='changeGPSDialog' v-bind:element='gpsDialog.element' :styles='gpsDialog.styles' >
      <template v-slot:dialog-content>
        <GpsMap ref='gpsMap' :mapConfig='mapConfig' style="margin-top: 2px;width: 100%;margin-left: 0px"></GpsMap>
      </template>
    </CustomDialog>
    <!-- 补丁包安装对话框-->
    <CustomDialog ref='patchInsatllDlg' v-bind:element='patchDialog.element' :styles='patchDialog.styles'>
      <template v-slot:dialog-content>
        <VersionPatch ref='patchDevice'></VersionPatch>
      </template>
    </CustomDialog>
  </div>
</template>

<script>
  import CustomDialog from '../../../common/CustomDialog';
  import BSButton from '@/components/deploymentManagement/runningEnvironment/BSDeviceEnviromentConfig/BSButton';
  import BSTable from '@/components/deploymentManagement/runningEnvironment/BSDeviceEnviromentConfig/BSTable';
  import AddBSDevice from '@/components/deploymentManagement/runningEnvironment/BSDeviceEnviromentConfig/AddBSDevice';
  import { EventBus } from '../../../../plugins/eventBus';
  import BsTable from "./BSTable";
  import BsButton from "./BSButton";
  import DeviceVersion from "@/components/deploymentManagement/deployedInstance/DeviceVersion";
  import VersionUpdate from "../../../../views/software/VersionUpdate";
  import VersionPatch from "../../../../views/software/VersionPatch";
  import VersionBack from "../../../../views/software/VersionBack";
  import GpsMap from "./GpsMap";
  import UpdateDevice from './EditBSDevice';


  export default {
    name: "BSDeviceEnvironment",
    components: {
      BsButton,
      BsTable,
      CustomDialog,
      BSButton,
      BSTable,
      AddBSDevice,
      DeviceVersion,
      VersionUpdate,
      GpsMap,
      UpdateDevice,
      VersionBack,
      VersionPatch
    },
    beforeCreate() {
      this.$axios.post('/lte/ems/sysmanager/map/queryConfig.html').then((response) => {
        const mapConf = response.data;
        this.mapConfig.latitude = mapConf.centerLatitude;
        this.mapConfig.longitude = mapConf.centerLongitude;
        this.mapConfig.zoom = mapConf.defaultZoom;
      });
    },
    data() {
      return {
        addBoolean:JSON.parse(sessionStorage.getItem('authMap')).basedevice.Add,
        delBoolean:JSON.parse(sessionStorage.getItem('authMap')).basedevice.Delete,
        upGradBoolean:JSON.parse(sessionStorage.getItem('authMap')).basedevice.Upgrade,
        downGradeBoolean:JSON.parse(sessionStorage.getItem('authMap')).basedevice.Switch,
        synBoolean:JSON.parse(sessionStorage.getItem('authMap')).basedevice.Sync,
        gpsBoolean:JSON.parse(sessionStorage.getItem('authMap')).basedevice.Sync,
        updateDevDialog:{
          element: {
            title:  this.$t('Topo.devModify'),
            isClose: true,
            refName: this.$t('Topo.devMange'),
            buttonGroup: [
                    { click: this.updateCancel, buttonModel: { content: this.$t('Topo.cancel') } },
                    { click: this.updateSubmit, buttonModel: { content: this.$t('Topo.confirm'), isPrimary: true } }
                ]
            },
            styles: {
                width: '800px',
                height: '700px',
                visible: false,
                model: true
            },
            messages: {
                title: this.$t('Topo.devModify'),
            }
        },
        devDialog: {
          element: {
            title: this.$t('Topo.devAdd'),
            isClose: true,
            refName: this.$t('Topo.devMange'),
            buttonGroup: [
              { click: this.addCancel, buttonModel: { content: this.$t('Topo.cancel') } },
              { click: this.addSubmit, buttonModel: { content: this.$t('Topo.confirm'), isPrimary: true } },
            ]
          },
          styles: {
            width: '740px',
            height: '740px',
            visible: false,
            model: true
          },
          messages: {
            title: this.$t('Topo.devAdd')
          }
        },
        confirmHeader: this.$t('Topo.devAdd'),
        refName: this.$t('Topo.devMange'),
        contenttemplateVue: function () {
                return { template : GpsMap }
        },
        gpsDialog: {
          element: {
            title: this.$t('DeployManagement.changeGPS'),
            isClose: true,
            refName: this.$t('DeployManagement.changeGPS'),
            nodestroy:true,
            buttonGroup: [
              { click: this.gpsCancel, buttonModel: { content: this.$t('Topo.cancel') } },
              { click: this.delSubmit, buttonModel: { content: this.$t('System.delete'), isPrimary: true } },
            ]
          },
          styles: {
            width: '1180px',
            height: '860px',
            visible: false,
            model: true
          },
          messages: {
            title: this.$t('DeployManagement.changeGPS')
          }
        },
        upDialog: {
          element: {
            title: this.$t('Topo.deviceUpdate'),
            isClose: true,
            refName: this.$t('Topo.deviceUpdate'),
            buttonGroup: [
              // { click: this.addCancel, buttonModel: { content: this.$t('Topo.cancel') } },
              { click: this.upgradeCancel, buttonModel: { content: this.$t('Topo.confirm'), isPrimary: true } },
            ]
          },
          styles: {
            width: '980px',
            height: 'auto',
            visible: false,
            model: true
          }
        },
        //
        patchDialog: {
          element: {
            title: this.$t('DeployManagement.patchUpgrade'),
            isClose: true,
            refName: this.$t('DeployManagement.patchUpgrade'),
            buttonGroup: [
              { click: this.patchInsatllCancel, buttonModel: { content: this.$t('Topo.confirm'), isPrimary: true } },
            ]
          },
          styles: {
            width: '980px',
            height: 'auto',
            visible: false,
            model: true
          }
        },
        reDialog: {
          element: {
            title: this.$t('Topo.deviceReback'),
            isClose: true,
            refName: this.$t('Topo.deviceReback'),
            buttonGroup: [
              // { click: this.rollbackCancel, buttonModel: { content: this.$t('Topo.cancel') } },
              { click: this.rollbackCancel, buttonModel: { content: this.$t('Topo.confirm'), isPrimary: true } },
            ]
          },
          styles: {
            width: '980px',
            height: 'auto',
            visible: false,
            model: true
          }
        },
        mapConfig: {
          longitude: 121.433,
          latitude: 28.662,
          zoom: 16,

        },
      }
    },
    methods: {
      notice(type) {
        switch (type) {
          case 'addDevice':
            this.addDevice();
            break;
          case 'editDevice':
            this.editDevice();
            break;
          case 'delDevice':
            this.delDevice();
            break;
          case 'upGrade':
            this.upGrade();
            break;
          case 'downGrade':
            this.downGrade();
            break;
          case 'synVersion':
            this.synVersion();
            break;
          case 'patchUpgrade':
            this.patchUpgrade();
            break;
          case 'changeGPS':
            this.changeGPS();
            break;
          case 'export':
            this.exportData();
            break;
          case 'exportAll':
            this.exportAllData();
            break;
          case 'import':
            this.importNeData();
            break;
          default:
            break;
        }
      },
      // 加载数据
      getDeviceListData() {
        this.$refs.bsTable.getDeviceListData();
      },
      // 按名称搜索
      search(searchValue) {
        this.$refs.bsTable.search(searchValue);
      },
      // 打开添加弹窗
      addDevice() {
        this.$refs.addDev.initData(true, 1);
        this.$refs.deviceDialog.show();
        this.$refs.addDev.bindValidate();
      },
      // 添加提交
      addSubmit() {
        this.$refs.addDev.outputs('BS');
        this.$refs.bsTable.getDeviceListData();
      },
      // 添加取消
      addCancel() {
        this.$refs.deviceDialog.clear();
        this.$refs.deviceDialog.close();
        this.$refs.upGradeDlg.clear();
        this.$refs.upGradeDlg.close();
      },
      rollbackCancel() {
        this.$refs.downGradeDlg.clear();
        this.$refs.downGradeDlg.close();
      },
      upgradeCancel() {
        this.$refs.upGradeDlg.clear();
        this.$refs.upGradeDlg.close();
      },
      //补丁包安装操作取消
      patchInsatllCancel() {
        this.$refs.patchInsatllDlg.clear();
        this.$refs.patchInsatllDlg.close();
      },
      editDevice() {
        var item = this.$refs.bsTable.getCheckedData(true);
        if(item.length === 1) {
            this.$refs.updateDevice.show();
            this.$refs.updatedev.initData(item[0]);
            this.$refs.updatedev.bindValidate();
        }else if(item.length > 1){
          EventBus.$emit('toast', {type: 'warning', content: this.$t('Topo.pleaseSelectOne')});
          return;
        }
        if(item.length === 0) {
          EventBus.$emit('toast', {type: 'warning', content: this.$t('Topo.pleaseSelect')});
          return;
        }
      },
      updateSubmit() {
        this.$refs.updatedev.outputs(res => {
         if ('true'==res) {
           this.$refs.bsTable.getDeviceListData();
         }
        })
      },
      updateCancel() {
        this.$refs.updateDevice.clear();
        this.$refs.updateDevice.close();
      },
      // 点击删除按钮
      delDevice() {
        this.$refs.bsTable.delDeviceConfirm();
      },
      // 打开升级弹窗
      upGrade() {
        this.upDialog.element.title = this.$t('Topo.deviceUpdate');
        this.getInitData(0);
      },
      // 打开补丁包升级弹窗
      patchUpgrade() {
        this.patchDialog.element.title = this.$t('DeployManagement.patchUpgrade');
        this.$refs.patchInsatllDlg.show();
      },
      // 打开回退弹窗
      downGrade() {
        this.upDialog.element.title = this.$t('Topo.deviceReback');
        this.getInitData(1);
      },
      // 获得初始化设备列表
      getInitData(upOrBack) {
        const This = this;
        // This.$axios.post(`/lte/ems/packageManager/getSuVersion4Device`).then(response => {
        // TODO 自测请求
        This.$axios.post('/lte/ems/env/serverGNBDevicePage').then(response => {//only GNB list
          if(response && response.status === 200 && response.data.errorCode === 'SUCCESS') {
            if(response.data === undefined || response.data.resultVal === undefined){
              return;
            }
            console.log(response);
            const param = {
              'upOrBack': upOrBack,
              'dataSource': response.data.resultVal[0]
            };
            // this.$refs.upDevice.init(param);
            if(upOrBack === 0){
              this.$refs.upGradeDlg.show();
            }else{
              this.$refs.downGradeDlg.show();
            }

          } else {
            EventBus.$emit('toast', {type: 'error', content: response.data.errorString});
          }
        });
      },
      // 设备弹窗确认按钮
      deConfirm() {
        this.$refs.upDevice.confirm();
      },
      // 版本同步
      synVersion() {
        this.$refs.bsTable.synVersion();
      },
      //更改GPS
      changeGPS(){
        this.$refs.bsTable.changeGPS();
      },
      delSubmit(){
        this.$refs.gpsMap.removeCurGPS();
      },
      gpsCancel(){
        this.$refs.gpsMap.cancel();
      },

      importNeData(){
         this.$refs.bsButton.addDialog();
      },
      exportData(){
        const selectedRecords = this.$refs.bsTable.rowSelecting();
           const neIds=[];
          if(selectedRecords.length > 0){
            for(let i in selectedRecords){
                neIds.push(selectedRecords[i].id);
            }
          }
         const param = {data: neIds};
        this.$loading.showLoadding(this.$t("SubscriberIms.waitTip"));
        axios({
                    method: 'post',
                    url: '/lte/ems/env/exportNes',
                    data:param,
                    // 二进制流文件，一定要设置成blob，默认是json
                    responseType: 'blob'
                  }).then(response => {
                    this.$loading.hideLoadding();
                    const link = document.createElement('a');
                    const blob = new Blob([response.data], { type: 'application/vnd.ms-excel' });
                    let fileNames = response.headers['content-disposition'] //获取到Content-Disposition;filename
                    let regFileNames = fileNames.match(/=(.*)$/)[1]; //文件名称  截取=后面的文件名称

                    link.style.display = 'none';
                    link.href = URL.createObjectURL(blob);
                    link.setAttribute("download", regFileNames);
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                     this.$loading.hideLoadding();
                  });
        },
        exportAllData(){
         const neIds=[];
         const param = {data: neIds};
        this.$loading.showLoadding(this.$t("SubscriberIms.waitTip"));
        axios({
                    method: 'post',
                    url: '/lte/ems/env/exportNes',
                    data:param,
                    // 二进制流文件，一定要设置成blob，默认是json
                    responseType: 'blob'
                  }).then(response => {
                    this.$loading.hideLoadding();
                    const link = document.createElement('a');
                    const blob = new Blob([response.data], { type: 'application/vnd.ms-excel' });
                    let fileNames = response.headers['content-disposition'] //获取到Content-Disposition;filename
                    let regFileNames = fileNames.match(/=(.*)$/)[1]; //文件名称  截取=后面的文件名称

                    link.style.display = 'none';
                    link.href = URL.createObjectURL(blob);
                    link.setAttribute("download", regFileNames);
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                     this.$loading.hideLoadding();
                  });
        }
    }
  }
</script>

